import { Model as s } from "../../../model.js";
class m extends s {
  constructor(e) {
    super(), this.home = e.home, this.service = e.service, this.common = e.common, this.inactive = e.inactive, this.disabled = e.disabled, this.timetable = e.timetable;
  }
}
export {
  m as KioskConfigurationModel
};
//# sourceMappingURL=kioskConfiguration.model.js.map
